<style scoped lang="scss">
.doc{
   border-radius: 4px;
   background: rgb(230, 255, 255);
   border: 1px solid rgb(107, 204, 204);
   padding: 10px;
   & table{
      & td, & th{
         color: #212121;
         font-size: 12px;
         font-weight: 500;
      }
      & .feather{
         margin-top: 2px;
         display: block;
      }
      & td div{
         border-bottom-color:rgb(204, 237, 237) !important;
         // border-bottom-style: dashed !important;
      }
   }
}
</style>
<template>
   <div id="settings" class="content content--borderless">
      <div class="content__breadcrumbs">
         <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
      </div>
      <div class="content__header" style="padding-bottom:30px">
         <div class="content__main-header align-items-center">
         <div class="content__title">
            <div class="content__title__name">Master Organisasi SDI</div>
            <div class="content__title__description">Daftar Pembina Data, Walidata dan Produsen Data</div>
         </div>
         <div class="ml-auto" v-if="!isProdusenData">
            <b-dropdown  size="sm"  toggle-class="d-flex align-items-center button button--primary button--sm px-2" >
               <template #button-content> <VueFeather type="plus" size="16" stroke-width="2" style="display:block"></VueFeather>&nbsp; Organisasi SDI</template>
               <b-dropdown-item  @click="addSdiOrganization('PEMBINA_DATA')" link-class="py-1 px-3  text-13" v-if="isSuperAdmin || isPembinaData"> Pembina Data</b-dropdown-item>
               <b-dropdown-item  @click="addSdiOrganization('WALIDATA')" link-class="py-1 px-3 text-13" v-if="isSuperAdmin || isPembinaData"> Walidata</b-dropdown-item>
               <b-dropdown-item  @click="addSdiOrganization('PRODUSEN_DATA')" link-class="py-1 px-3 text-13" v-if="isSuperAdmin || isPembinaData || isWalidata"> Produsen Data </b-dropdown-item>
            </b-dropdown>
            <!-- <button type="button" class="button" variant="primary" size="sm"  @click="addSdiOrganization" v-if="(isSuperAdmin || isPembinaDataPusat || isPembinaDataProvinsi)">
               <VueFeather type="plus" size="16" stroke-width="2" style="display:block"></VueFeather>&nbsp;
               Tambah Pembina Data
            </button>
            <button type="button" class="button" variant="primary" size="sm"  @click="addSdiOrganization" v-if="(isSuperAdmin || isPembinaData)">
               <VueFeather type="plus" size="16" stroke-width="2" style="display:block"></VueFeather>&nbsp;
               Tambah Walidata
            </button>
            <button type="button" class="button" variant="primary" size="sm"  @click="addSdiOrganization" v-if="(isSuperAdmin || isPembinaData || isWalidata)">
               <VueFeather type="plus" size="16" stroke-width="2" style="display:block"></VueFeather>&nbsp;
               Tambah Produsen Data
            </button> -->
         </div>
         </div>
         <!-- <div class="tab-control">
            <div  v-for="(item,index) in tab.items" :key="index" @click="tabChange(index)"
               :class="tab.index == index ? 'tab-control__item tab-control__item--active':'tab-control__item'" >
               <div class="tab-control__item__name">{{item.name}}</div>
            </div>
         </div> -->
      </div>
      <div class="content__body" style="margin-top:-35px">
         <div class="table-search mb-2 form form--sm">
            <div class="w-100">
               <b-input-group >
                  <b-input-group-prepend is-text class="bg-none">
                     <VueFeather type="search" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
                  </b-input-group-prepend>
                  <b-form-input 
                     type="search"
                     debounce="500"
                     v-model="filter.name" 
                     :placeholder="'Cari '+tab.items[tab.index].name+' berdasarkan nama . . .'" 
                     class="border-left-0 min-w-400"></b-form-input>
               </b-input-group>
            </div>
            
            <div class="w-100 d-flex">
               <Treeselect 
                  clearable
                  class="mr-2"
                  placeholder="Role"
                  v-model="filter.sdiRole"
                  :options="options.sdiRole"
                  @input="filterRoleChanged"
                  
               />
               <Treeselect 
                  clearable
                  class="mr-2"
                  placeholder="Provinsi"
                  v-model="filter.provinceCode"
                  :options="options.province"
                  :normalizer="provinceNormalizer"
                  :disabled="provinceFilterDisabled"
                  @input="filterProvinceCodeChanged"
                  
               />
               <Treeselect 
                  clearable
                  placeholder="Kabupaten/Kota"
                  v-model="filter.cityCode"
                  :options="options.city"
                  :loadOptions="loadOptions"
                  :disabled="!filter.provinceCode || cityFilterDisabled"
                  :normalizer="cityNormalizer"
                  @input="filterCityCodeChanged"
               />
            </div>
         </div>
         <div class="table-wrapper mb-5">
            <b-table
               class="table--light"
               show-empty
               :items="sdiOrganizationTable.items"
               :fields="sdiOrganizationTable.fields"
            >
               <template #cell(no)="data">
                  {{
                     sdiOrganizationTable.pagination.currentPage == 1 ? 
                     ( data.index + 1 ) : ((sdiOrganizationTable.pagination.currentPage-1)*sdiOrganizationTable.pagination.pageSize)+data.index
                  }}
               </template>
               <template #cell(province)="data">
                  {{data.item.details.province.name}}
               </template>
               <template #cell(city)="data">
                  {{data.item.details.city.name}}
               </template>
               <template #cell(role)="data">
                  <span :class="data.value == 'PEMBINA_DATA' ? 'status status--submitted' : data.value == 'WALIDATA' ? 'status status--pending' : 'status status--published'">
                     {{data.value == 'PEMBINA_DATA' ? 'Pembina Data' : data.value == 'WALIDATA' ? 'Walidata' : 'Produsen Data'}}
                  </span>
                  
               </template>
               <template #cell(phone_fax)="data">
                  {{
                     data.item.details.phone && data.item.details.fax ? data.item.details.phone + ' / ' + data.item.details.fax :
                     data.item.details.phone && !data.item.details.fax ? data.item.details.phone :
                     !data.item.details.phone && data.item.details.fax ? data.item.details.fax : '-'
                  }}
               </template>
               <template #cell(action)="data">
                  <div class="d-flex justify-content-center">
                     <b-link  
                        class="button button--action button--action--view " v-b-tooltip.hover title="Lihat Detil" @click="showDetailWalidata(data.item)"
                     > 
                        <VueFeather type="eye" size="14"></VueFeather>
                     </b-link>
                     <b-link  
                        
                        class="button button--action button--action--edit " v-b-tooltip.hover title="Edit" @click="updateSdiOrganization(data.item)"
                        v-if="sdiOrganizationEditable(data.item)"
                     >
                        <VueFeather type="edit-3" size="14"></VueFeather>
                     </b-link>
                     <b-link  
                        v-if="viewSdiOrganizationUser(data.item)"
                        class="button button--action button--action--view " v-b-tooltip.hover title="Lihat daftar pengguna" :to="'/pengaturan/sdi/pembina-data/'+data.item.id+'/user'"
                        
                     >
                        <VueFeather type="user" size="14"></VueFeather>
                     </b-link>
                  </div>
               </template>
               <template #empty>
                  <div class="table__empty">
                  <div v-if="sdiOrganizationTable.isLoading">
                     <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                  <div v-else>
                     <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                        Belum ada data yang tersedia
                  </div>
                  </div>
               </template> 
            </b-table>
            <b-pagination
               class="mt-3 "
               align="center"
               v-if="sdiOrganizationTable.items.length > 0 && sdiOrganizationTable.isLoading == false"
               v-model="sdiOrganizationTable.pagination.currentPage"
               :total-rows="sdiOrganizationTable.pagination.totalElements"
               :per-page="sdiOrganizationTable.pagination.pageSize"
               @input="getOrganizationSdiList"
            ></b-pagination>
         </div>

         <b-tabs v-model="tab.index" nav-class="d-none" content-class="p-0">
            <!-- <b-tab>
               <div class="table-wrapper">
                  <b-table
                     class="table--light"
                     show-empty
                     :items="sdiOrganizationTable.items"
                     :fields="sdiOrganizationTable.fields"
                  >
                     <template #cell(no)="data">
                        {{
                           sdiOrganizationTable.pagination.currentPage == 1 ? 
                           ( data.index + 1 ) : ((sdiOrganizationTable.pagination.currentPage-1)*sdiOrganizationTable.pagination.pageSize)+data.index
                        }}
                     </template>
                     <template #cell(province)="data">
                        ({{data.item.details.province.code}}) {{data.item.details.province.name}}
                     </template>
                     <template #cell(city)="data">
                        ({{data.item.details.city.code}}) {{data.item.details.city.name}}
                     </template>
                     <template #cell(role)="data">
                        {{data.value == 'PEMBINA_DATA' ? 'Pembina Data' : data.value == 'WALIDATA' ? 'Walidata' : 'Produsen Data'}}
                     </template>
                     <template #cell(phone)="data">
                        {{data.item.details.phone ? data.item.details.phone : '-'}}
                     </template>
                     <template #cell(fax)="data">
                        {{data.item.details.fax ? data.item.details.fax : '-'}}
                     </template>
                     <template #cell(action)="data">
                        <div class="d-flex justify-content-center">
                           <b-link  
                              class="button button--action button--action--view " v-b-tooltip.hover title="Lihat Detil" @click="showDetailWalidata(data.item)"
                           > 
                              <VueFeather type="eye" size="14"></VueFeather>
                           </b-link>
                           <b-link  
                              v-if="isSuperAdmin || isPembinaData"
                              class="button button--action button--action--edit " v-b-tooltip.hover title="Edit" @click="editWalidata(data.item)"
                              :disabled="!canEditPembinaData(data.item)"
                           >
                              <VueFeather type="edit-3" size="14"></VueFeather>
                           </b-link>
                           <b-link  
                              v-if="isSuperAdmin || isPembinaData"
                              class="button button--action button--action--view " v-b-tooltip.hover title="Lihat daftar pengguna" :to="'/pengaturan/sdi/pembina-data/'+data.item.id+'/user'"
                              
                           >
                              <VueFeather type="user" size="14"></VueFeather>
                           </b-link>
                        </div>
                     </template>
                     <template #empty>
                        <div class="table__empty">
                        <div v-if="sdiOrganizationTable.isLoading">
                           <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                        <div v-else>
                           <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                              Belum ada data yang tersedia
                        </div>
                        </div>
                     </template> 
                  </b-table>
                  <b-pagination
                     class="mt-3 "
                     align="center"
                     v-if="sdiOrganizationTable.items.length >0 && sdiOrganizationTable.isLoading == false"
                     v-model="sdiOrganizationTable.pagination.currentPage"
                     :total-rows="sdiOrganizationTable.pagination.totalElements"
                     :per-page="sdiOrganizationTable.pagination.pageSize"
                     @input="getOrganizationSdiList"
                  ></b-pagination>
               </div>
            </b-tab> -->
            <!-- <b-tab>
               <div class="table-wrapper">
                  <b-table
                     class="table--light"
                     show-empty
                     :items="walidataTable.items"
                     :fields="walidataTable.fields"
                  >
                     <template #cell(no)="data">
                        {{
                           walidataTable.pagination.currentPage == 1 ? 
                           ( data.index + 1 ) : ((walidataTable.pagination.currentPage*walidataTable.pagination.pageSize)+(data.index + 1))
                        }}
                     </template>
                     <template #cell(name)="data">
                        {{data.item.details.abbreviation ? data.item.details.name +' ('+data.item.details.abbreviation+')' : data.item.details.name}}
                     </template>
                     <template #cell(phone)="data">
                        {{data.item.details.phone ? data.item.details.phone : '-'}}
                     </template>
                     <template #cell(fax)="data">
                        {{data.item.details.fax ? data.item.details.fax : '-'}}
                     </template>
                     <template #cell(action)="data">
                        <div class="d-flex justify-content-center">
                           <b-link  
                              class="button button--action button--action--view " v-b-tooltip.hover title="Lihat Detil" @click="showDetailWalidata(data.item)"
                           > 
                              <VueFeather type="eye" size="14"></VueFeather>
                           </b-link>
                           <b-link  
                              class="button button--action button--action--edit " v-b-tooltip.hover title="Edit" :disabled="!canEditWalidata(data.item)" @click="editWalidata(data.item)"
                           > 
                              <VueFeather type="edit-3" size="14"></VueFeather>
                           </b-link>
                           <b-link  
                              v-if="isSuperAdmin || isPembinaData"
                              class="button button--action button--action--view " v-b-tooltip.hover title="Lihat daftar pengguna" :to="'/pengaturan/sdi/walidata/'+data.item.id+'/user'"
                           >
                              <VueFeather type="user" size="14"></VueFeather>
                           </b-link>
                        </div>
                     </template>
                     <template #empty>
                        <div class="table__empty">
                        <div v-if="walidataTable.isLoading">
                           <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                        <div v-else>
                           <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                              Belum ada data yang tersedia
                        </div>
                        </div>
                     </template> 
                  </b-table>
                  <b-pagination
                     class="mt-3 "
                     align="center"
                     v-if="walidataTable.items.length >0 && walidataTable.isLoading == false"
                     v-model="walidataTable.pagination.currentPage"
                     :total-rows="walidataTable.pagination.totalElements"
                     :per-page="walidataTable.pagination.pageSize"
                     @input="getWalidata"
                  ></b-pagination>
               </div>
            </b-tab>
            <b-tab>
               <div class="table-wrapper">
                  <b-table
                     class="table--light"
                     show-empty
                     :items="produsenDataTable.items"
                     :fields="produsenDataTable.fields"
                  >
                     
                     <template #cell(no)="data">
                        {{
                           produsenDataTable.pagination.currentPage == 1 ? 
                           ( data.index + 1 ) : ((produsenDataTable.pagination.currentPage*produsenDataTable.pagination.pageSize)+(data.index + 1))
                        }}
                     </template>
                     <template #cell(name)="data">
                        {{data.item.details.abbreviation ? data.item.details.name +' ('+data.item.details.abbreviation+')' : data.item.details.name}}
                     </template>
                     <template #cell(phone)="data">
                        {{data.item.details.phone ? data.item.details.phone : '-'}}
                     </template>
                     <template #cell(fax)="data">
                        {{data.item.details.fax ? data.item.details.fax : '-'}}
                     </template>
                     <template #cell(action)="data">
                        <div class="d-flex justify-content-center">
                           <b-link  
                              class="button button--action button--action--view " v-b-tooltip.hover title="Lihat Detil" @click="showDetailWalidata(data.item)"
                           > 
                              <VueFeather type="eye" size="14"></VueFeather>
                           </b-link>
                           <b-link  
                              class="button button--action button--action--edit " v-b-tooltip.hover title="Edit" :disabled="!canEditProdusenData(data.item)" @click="editProdusenData(data.item)"
                           > 
                              <VueFeather type="edit-3" size="14"></VueFeather>
                           </b-link>
                           <b-link  

                              v-if="isSuperAdmin || isPembinaData"
                              :disabled="!data.item.details.email || (data.item.details.email.split('@')[1] != 'bps.go.id')"
                              class="button button--action button--action--view " v-b-tooltip.hover title="Lihat daftar pengguna" :to="'/pengaturan/sdi/walidata/'+data.item.id+'/user'"
                           >
                              <VueFeather type="user" size="14"></VueFeather>
                           </b-link>
                        </div>
                     </template>
                     <template #empty>
                        <div class="table__empty">
                        <div v-if="produsenDataTable.isLoading">
                           <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                        <div v-else>
                           <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                              Belum ada data yang tersedia
                        </div>
                        </div>
                     </template>
                  </b-table>
                  <b-pagination
                     class="mt-3 "
                     align="center"
                     v-if="produsenDataTable.items.length >0 && produsenDataTable.isLoading == false"
                     v-model="produsenDataTable.pagination.currentPage"
                     :total-rows="produsenDataTable.pagination.totalElements"
                     :per-page="produsenDataTable.pagination.pageSize"
                     @input="getProdusenData"
                  ></b-pagination>
               </div>
            </b-tab> -->
            <b-tab></b-tab>
         </b-tabs>
      </div>

   <b-modal hide-header hide-footer size="xl" id="modal-add-organization" modal-class="modal-secondary primary" >
      <div class="modal__header secondary">
         <div class="modal__header__icon">
         <VueFeather type="home" size="18" stroke-width="2"></VueFeather> 
         </div>
         <div class="">
         <div class="modal__title"> 
            {{isNew ? 'Tambah ' : 'Edit '}}
            {{organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ' }}
         </div>
         <div class="modal__description"> 
            Isikan secara lengkap form sesuai dengan panduan yang ada
         </div>
         </div>
         <div class="modal__header__close">
         <b-button  class="button button--action button--action--view" @click="$bvModal.hide('modal-add-organization')">
            <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
         </b-button>
         </div>
      </div>
      <div class="modal__body my-2 form form--sm">
         <b-row>
            <b-col>
               <ValidationObserver ref="organizationObserver" v-slot="{validate}">
                  <ValidationProvider :name="'Nama ' + (organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ')" rules="required" v-slot="{errors}">
                     <b-form-group label="Nama">
                        <b-form-input 
                        v-model="organization.name" 
                        :placeholder="'Nama ' + (organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ')"
                        :state="errors[0] ? false: (organization.name ? true : null)"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                     </b-form-group>
                  </ValidationProvider>
                  <b-form-group label="Singkatan / Akronim / Gabungan Singkatan & Akronim">
                     <b-form-input 
                        v-model="organization.abbreviation" 
                        :placeholder="'Singkatan Nama'+tab.items[tab.index].name" 
                        :state="organization.abbreviation ? true : null"
                     >
                     </b-form-input>
                  </b-form-group>
                  
                  <div class="mb-2">
                     <b-row class="pt-2 pb-0">
                        <b-col>
                           <ValidationProvider :name="'Provinsi ' + (organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ')" rules="required" v-slot="{errors}">
                              <b-form-group label="Provinsi">
                                 <Treeselect 
                                    clearable
                                    placeholder="Provinsi"
                                    v-model="organization.province.code"
                                    :options="options.province"
                                    :normalizer="provinceNormalizer"
                                    :disabled="provinceFormDisabled"
                                    :class="errors[0] ? 'invalid': (organization.province.code ? 'valid' : null)"
                                    @input="updateFormCityOptions"
                                 />
                                 <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                              </b-form-group>
                           </ValidationProvider>
                        </b-col>
                        <b-col>
                           <ValidationProvider :name="'Kabupaten/Kota' + (organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ')" rules="required" v-slot="{errors}">
                              <b-form-group label="Kabupaten/Kota">
                                 <Treeselect 
                                    clearable
                                    placeholder="Kabupaten/Kota"
                                    v-model="organization.city.code"
                                    :options="options.city"
                                    :disabled="!organization.province.code|| cityFormDisabled"
                                    :normalizer="cityNormalizer"
                                    :class="errors[0] ? 'invalid': (organization.city.code ? 'valid' : null)"
                                 />
                                 <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                              </b-form-group>
                           </ValidationProvider>
                        </b-col>
                     </b-row>
                     <ValidationProvider :name="'Alamat ' + (organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ')" rules="required" v-slot="{errors}">
                        <b-form-group label="Alamat">
                           <b-form-textarea 
                              rows="3"
                              v-model="organization.address" 
                              :placeholder="'Isikan alamat lengkap ' + (organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ')"
                              :state="errors[0] ? false: (organization.address ? true : null)"
                           >
                           </b-form-textarea>
                           <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                     </ValidationProvider>
                  </div>
                  <ValidationProvider :name="'Email ' + (organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ')" rules="required|email" v-slot="{errors}">
                     <b-form-group label="Email">
                        <b-form-input 
                           v-model="organization.email" 
                           :placeholder="'Email aktif ' + (organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ')"
                           :state="errors[0] ? false: (organization.email ? true : null)"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                     </b-form-group>
                  </ValidationProvider>
                  
                  <b-row>
                     <b-col>
                        <b-form-group label="No. Telepon">
                           <b-form-input 
                              v-model="organization.phone" 
                              :placeholder="'No. Telepon ' + (organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ')"
                              :state="organization.phone ? true : null"
                           >
                           </b-form-input>
                        </b-form-group>
                     </b-col>
                     <b-col>
                        <b-form-group label="Fax">
                           <b-form-input 
                              v-model="organization.fax" 
                              :placeholder="'Fax ' + (organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ')"
                              :state="organization.fax ? true : null"
                           >
                           </b-form-input>
                        </b-form-group>
                     </b-col>
                  </b-row>
                   <!-- <ValidationProvider name="Walidata Pusat" rules="required" v-slot="{errors}" v-if="tab.index==2">
                    <b-form-group label="Walidata Pusat">
                      <Treeselect 
                        clearable
                        valueFormat="object"
                        placeholder="Nama Walidata Pusat"
                        v-model="walidata"
                        :class="errors[0] ? 'invalid': (walidata? 'valid' : null)"
                        :async="true"
                        :loadOptions="walidataLoadOptions"
                        :options="options.walidata_pusat"
                        :normalizer="walidataNormalizer"
                        @input="walidataChanged"
                        searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
                      />
                      <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>  -->
               
                  <div class="d-flex align-items-center justify-content-end">
                     <b-button  v-if="isNew && !isUpdate" class="button button--primary" @click="()=>{
                        validate().then(result=>{
                           if(result){
                              saveOrganization();
                           }
                        })   
                     }">Simpan</b-button>
                     <b-button v-if="!isNew && isUpdate" class="button button--primary" @click="()=>{
                        validate().then(result =>{
                           if(result){
                              updateOrganization();
                           }
                        })   
                     }" >Update</b-button>
                  </div>
               </ValidationObserver>
            </b-col>
            <b-col cols="5">
               <div class="doc">
                  <b-table-simple borderless>
                     <b-tbody>
                        <tr>
                           <b-td  class="w-20" style="color:#255454; font-weight:700">1.</b-td>
                           <b-td>
                              <div class="text-bold" style="color:#255454">
                                 Nama {{organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data '}} tidak boleh disingkat atau mengandung singkatan/akronim.
                              </div>
                              <div class="d-flex border-bottom py-1">
                                 <div class="mr-1"><VueFeather type="check" size="15" stroke="green" stroke-width="3" style="margin-top:2px"></VueFeather></div>
                                 <div>Pusat Data dan Informasi Kementerian Kesehatan</div>
                              </div>
                              <div class="d-flex border-bottom py-1">
                                 <div class="mr-1"><VueFeather type="check" size="15" stroke="green" stroke-width="3" style="margin-top:2px"></VueFeather></div>
                                 <div>Dinas Komunikasi dan Informatika Provinsi Jawa Barat</div>
                              </div>
                              <div class="d-flex border-bottom py-1">
                                 <div class="mr-1"><VueFeather type="check" size="15" stroke="green" stroke-width="3" style="margin-top:2px"></VueFeather></div>
                                 <div>Dinas Komunikasi dan Informatika Kabupaten Garut</div>
                              </div>
                              <div class="d-flex border-bottom py-1">
                                 <div class="mr-1"><VueFeather type="x" size="15" stroke="red" stroke-width="3" style="margin-top:2px"></VueFeather></div>
                                 <div>Pusdatin Kemenkes</div>
                              </div>
                              <div class="d-flex border-bottom py-1">
                                 <div class="mr-1"><VueFeather type="x" size="15" stroke="red" stroke-width="3" style="margin-top:2px"></VueFeather></div>
                                 <div>Dinas Komunikasi dan Informatika (Diskominfo) Provinsi Jawa Barat</div>
                              </div>
                              <div class="d-flex py-1">
                                 <div class="mr-1"><VueFeather type="x" size="15" stroke="red" stroke-width="3" style="margin-top:2px"></VueFeather></div>
                                 <div>Diskominfo Kab. Garut</div>
                              </div>
                           </b-td>

                        </tr>
                        <tr>
                           <b-td  class="w-20" style="color:#255454; font-weight:700">2.</b-td>
                           <b-td>
                              <div class="text-bold" style="color:#255454">
                                 Singkatan nama instansi pemerintah terdiri atas susunan huruf awal dari setiap kata pada kelompok kata 
                                 yang disingkat dan ditulis dengan huruf kapital, tanpa tanda titik. Contoh:
                              </div>
                              <div class="d-flex border-bottom py-1">
                                 <div class="mr-1"><VueFeather type="check" size="15" stroke="green" stroke-width="3" style="margin-top:2px"></VueFeather></div>
                                 <div>Badan Pusat Statistik disingkat BPS</div>
                              </div>
                              <div class="d-flex border-bottom py-1">
                                 <div class="mr-1"><VueFeather type="check" size="15" stroke="green" stroke-width="3" style="margin-top:2px"></VueFeather></div>
                                 <div>Badan Standardisasi Nasional disingkat BSN</div>
                              </div>
                           </b-td>
                        </tr>
                        <tr>
                           <b-td  class="w-20" style="color:#255454; font-weight:700">3.</b-td>
                           <b-td>
                              <div class="text-bold" style="color:#255454">
                                 Akronim nama instansi pemerintah merupakan kependekan dua kata atau lebih yang berbentuk gabungan suku kata 
                                 unsurunsur nama tersebut di atas. Akronim nama instansi pemerintah diperlakukan sebagai sebuah kata yang diawali 
                                 dengan huruf kapital, diikuti dengan huruf kecil, dan tidak diakhiri dengan tanda titik. Contoh:
                              </div>
                              <div class="d-flex border-bottom py-1">
                                 <div class="mr-1"><VueFeather type="check" size="15" stroke="green" stroke-width="3" style="margin-top:2px"></VueFeather></div>
                                 <div>Akronim untuk Kementerian Dalam Negeri adalah Kemendagri</div>
                              </div>
                              <div class="d-flex border-bottom py-1">
                                 <div class="mr-1"><VueFeather type="check" size="15" stroke="green" stroke-width="3" style="margin-top:2px"></VueFeather></div>
                                 <div>Akronim untuk Kementerian Pertanian adalah Kementan</div>
                              </div>
                           </b-td>
                        </tr>
                        <tr>
                           <b-td  class="w-20" style="color:#255454; font-weight:700">4.</b-td>
                           <b-td>
                              <div class="text-bold" style="color:#255454">
                                 Gabungan singkatan dan akronim adalah gabungan singkatan dan akronim atau akronim dan singkatan. 
                              </div>
                              <div class="d-flex border-bottom py-1">
                                 <div class="mr-1"><VueFeather type="check" size="15" stroke="green" stroke-width="3" style="margin-top:2px"></VueFeather></div>
                                 <div>Pemerintah Provinsi Bengkulu menjadi Pemprov Bengkulu</div>
                              </div>
                              <div class="d-flex border-bottom py-1">
                                 <div class="mr-1"><VueFeather type="check" size="15" stroke="green" stroke-width="3" style="margin-top:2px"></VueFeather></div>
                                 <div>Pemerintah Provinsi Jawa Barat menjadi Pemprov Jabar</div>
                              </div>
                           </b-td>
                        </tr>
                     </b-tbody>
                  </b-table-simple>
               </div>
            </b-col>
         </b-row>
      </div>
   </b-modal>

   <b-modal  hide-header hide-footer id="modal-delete" size="sm" content-class="modal--confirmation text-center" >
      <div class="p-3 text-danger" >
         <div >
         <VueFeather type="x-circle" size="60" stroke-width="2" stroke="#ff0055"></VueFeather>
         </div>
         <div class="text-center mt-2" style="font-size:16px;font-weight:600;color:#ff0055;">
         Apakah anda yakin menghapus item ini?
         </div>
         <div class="mt-1" style="color:#2e2e2e;font-weight:500;opacity:0.8;font-size:13px;letter-spacing:.2px">
         Ketika dihapus, item tidak bisa dikembalikan lagi, kecuali anda melakukan input ulang
         </div>
      </div>
      <div class="mt-3 mb-2">
         <b-button class="i-button mr-2" 
         v-on:click="()=>{$bvModal.hide('modal-delete');}"
         >Batal</b-button>
         <b-button class="i-button i-button-danger" 
         >Hapus</b-button>
      </div>
   </b-modal>

   <b-modal hide-header hide-footer id="modal-error" size="sm" content-class="modal--error text-center mt-5" dialog-class="d-flex justify-content-center">
      <div>
        <div class="text-center py-5 px-2" style="color:red">
          <div class="mb-3 d-flex justify-content-center align-item-center">
            <div class="border mx-4 " style="border-color:#F48FB1 !important;width:40%">
              <div style="position:relative;background-color:#FCE4EC;height:20px;border-color:#F48FB1 !important" class="border-bottom mb-2" >
                <div style="position:absolute;top:-10px;right:-10px"><VueFeather type="x-circle" size="20" stroke-width="1.5" fill="#FCE4EC"></VueFeather></div>
              </div>
              <div class="px-3 py-2" style="">
                <b-skeleton animation width="85%" height="10px" style="background-color:#fff1f6;border:1px solid #F8BBD0;margin-bottom:10px"></b-skeleton>
                <b-skeleton animation width="55%" height="10px"></b-skeleton>
                <b-skeleton animation width="70%" height="10px"></b-skeleton>
                <b-skeleton animation width="100%" height="10px"></b-skeleton>
              </div>
            </div>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            {{modal.error.title}} 
          </div>
          <div style="font-weight:500;font-size:13px;color:#616161;word-break: break-word;">
            {{modal.error.description}} 
          </div>
          <div class="mt-3">
            <b-button 
              class="i-button"
              style="color:white !important;background-color:#2e2e2e !important;padding:3px 10px;border-radius:3px !important; font-weight:600" 
              v-on:click="()=>{$bvModal.hide('modal-error');}">OK</b-button>
          </div>
        </div>
      </div>
    </b-modal>

   <b-modal hide-header hide-footer size="lg" id="modal-detail-organization" modal-class="modal-secondary primary" >
      <div class="modal__header secondary">
         <div class="modal__header__icon">
         <VueFeather type="home" size="18" stroke-width="2"></VueFeather> 
         </div>
         <div class="">
         <div class="modal__title"> 
            Detail {{organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ' }}
         </div>
         <div class="modal__description"> 
            Informasi lengkap tentang {{organizationRole=='PEMBINA_DATA' ? 'Pembina Data '  : organizationRole=='WALIDATA' ? 'Walidata '  :'Produsen Data ' }}
         </div>
         </div>
         <div class="modal__header__close">
         <b-button  class="button button--action button--action--view" @click="$bvModal.hide('modal-detail-organization')">
            <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
         </b-button>
         </div>
      </div>
      <div class="modal__body mt-2" v-if="organizationDetails">
         <b-table-simple class="table--stacked table--stacked--primary" >
            <b-tbody>
               <b-tr>
                  <b-th>Nama</b-th>
                  <b-td>{{organizationDetails.name}}</b-td>
               </b-tr>
               <b-tr>
                  <b-th class="w-200 text-wrap">Singkatan</b-th>
                  <b-td>{{organizationDetails.abbreviation ? organizationDetails.abbreviation : '-'}}</b-td>
               </b-tr>
               <b-tr>
                  <b-th>Provinsi</b-th>
                  <b-td>{{organizationDetails.province.name}}</b-td>
               </b-tr>
               <b-tr>
                  <b-th>Kabupaten / Kota</b-th>
                  <b-td>{{organizationDetails.city.name}}</b-td>
               </b-tr>
               <b-tr>
                  <b-th>Alamat</b-th>
                  <b-td>{{organizationDetails.address}}</b-td>
               </b-tr>
               <b-tr>
                  <b-th>No. Telepon</b-th>
                  <b-td>{{organizationDetails.phone ? organizationDetails.phone : '-'}}</b-td>
               </b-tr>
               <b-tr>
                  <b-th>Fax</b-th>
                  <b-td>{{organizationDetails.fax ? organizationDetails.fax : '-'}}</b-td>
               </b-tr>
               <b-tr>
                  <b-th>Email</b-th>
                  <b-td>{{organizationDetails.email ? organizationDetails.email : '-'}}</b-td>
               </b-tr>
               <b-tr v-if="tab.index==2">
                  <b-th>Walidata</b-th>
                  <b-td>{{organizationDetails.walidata ? organizationDetails.walidata.name : '-'}}</b-td>
               </b-tr>
            </b-tbody>
         </b-table-simple>
      </div>
      <div class="modal__footer border-top-0 pt-0">
         <div class="modal__footer__action">
         <b-button class="button button--primary" @click="$bvModal.hide('modal-detail-organization');">
            Tutup
         </b-button>
         </div>
      </div>
   </b-modal>

   <b-modal hide-header hide-footer size="sm" id="modal-loading"  content-class="modal modal--confirmation text-center p-2" centered dialog-class="d-flex justify-content-center">
      <div class="text-center px-3 py-4">
         <img src="@/assets/img/loader.gif" width="100" height="100" />
         <div style="font-weight:600;font-size:16px;color:#01ad85">
         Mohon tunggu sebentar 
         </div>
         <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
         Proses penghapusan sedang berlangsung
         </div>
      </div>
   </b-modal>

   <b-toast id="toast" variant="danger" solid body-class="text-manrope text-medium" no-close-button toaster="b-toaster-top-center">
      <template #toast-title>
        <div class="d-flex flex-grow-1 align-items-center text-manrope text-semi-bold">
          <b-img blank blank-color="#e32929" class="mr-2" width="10" height="10"></b-img>
          <strong class="mr-auto">{{toast.title}}!</strong>
          <!-- <small class="text-muted mr-2">{{toast.time}}</small> -->
        </div>
      </template>
      {{toast.message}}
    </b-toast>

    
  </div>
</template>

<script>
import "@/assets/scss/main.scss";
import "@/assets/scss/treeselect.scss";
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VueFeather from 'vue-feather';
import store from "../../store";
import Treeselect from '@riophae/vue-treeselect'
import SdsService from "@/services/SdsService";
import SdiOrganizationService from "@/services/SdiOrganizationService";
import Breadcrumbs from "@/components/Breadcrumbs";
import { ValidationObserver,ValidationProvider } from "vee-validate";
import wilayahService from "../../services/WilayahService";
import * as role from "@/views/ms/SdiRole.js";
import moment from 'moment'
export default{
   components:{
      ValidationObserver,
      ValidationProvider,
      Treeselect,
      VueFeather,
      Breadcrumbs
   },
  data() {
    return {
      initiated:false,
      breadcrumbs:[
         {
            text:'Beranda',
            href:'/',
         },
         {
            text:'Pengaturan',
            href:'#',
         },
         {
            text:'Organisasi SDI',
            href:'',
            active:true,
         }
      ],
      toast:{
        title:null,
        message:null,
        time:null
      },
      tab:{
        index:0,
        items:[
          {
            name:'Pembina Data',
            count : 0,
          },
          {
            name:'Walidata',
            count : 0,
          },
          {
            name:'Produsen Data',
            count : 0,
          },
        ]
      },
      user:null,
      userRoles:[],
      produsenData:null,
      myOrganizationId:null,
      settingSubmissionPeriod:null,
      submissionPeriod:null,

      provinceFormDisabled:false,
      cityFormDisabled:false,

      provinceFilterDisabled:false,
      cityFilterDisabled:false,
      
      filter:{
         name:null,
         provinceCode:null,
         cityCode: null,
         sdiRole: null,
      },

      walidata:null,

      provinceCode:null,
      cityCode:null,

      organizationDetails:{
        name:null,
        abbreviation:null,
        address:null,
        phone:null,
        fax:null,
        email:null,
        province:{
         code:null,
         name:null
        },
        city:{
         code:null,
         name:null
        },
        level:'PUSAT',
        walidata : null,
      },
      isNew:false,
      isUpdate:false,
      updatedId:null,
      organizationRole:null,
      organization:{
         id:null,
         name:null,
         abbreviation:null,
         address:null,
         phone:null,
         fax:null,
         email:null,
         province:{
            code:null,
            name:null
         },
         city:{
            code:null,
            name:null
         },
         level:'PUSAT',
         walidata : null,
      },
      sdiOrganizationTable:{
         name:null,
         provinceCode:null,
         cityCode:null,
         isLoading:false,
         items: [],
         fields:[
            {
               key:'no',
               class:'text-center w-51'
            },
            
            {
               key:'province',
               label: 'Provinsi',
               class:'text-left text-nowrap'
            },
            {
               key:'city',
               label: 'Kabupaten/Kota',
               class:'text-left text-nowrap'
            },
            {
               key: 'name',
               label: 'Organisasi',
               class:'text-left'
            },
            {
               key:'details.address',
               label: 'Alamat',
               class:'text-left '
            },
            {
               key:'phone_fax',
               label: 'No. Telepon/Fax',
               thClass:'text-left w-101'
            },
            {
               key:'details.email',
               label: 'Email',
               class:'text-left w-101'
            },
            {
               key:'role',
               label: 'Role',
               class:'text-center text-nowrap'
            },
            {
               key:'action',
               label: 'Aksi',
               class:'text-center text-nowrap w-101'
            },
         ],
         pagination:{
            currentPage:1,
            pageSize: 10,
            totalPages: null,
            totalElements:0,
         },
      },
      pembinaDataTable:{
         name:null,
         provinceCode:null,
         cityCode:null,
         isLoading:false,
         items: [],
         fields:[
            {
               key:'no',
               class:'text-center w-51'
            },
            {
               key:'province',
               label: 'Provinsi',
               class:'text-left w-110'
            },
            {
               key:'city',
               label: 'Kabupaten/Kota',
               class:'text-left w-110'
            },
            {
               key: 'name',
               label: 'Nama Pembina Data',
               class:'text-left'
            },
            {
               key:'details.address',
               label: 'Alamat',
               class:'text-left '
            },
            {
               key:'details.phone',
               label: 'No. Telepon',
               thClass:'text-left w-150'
            },
            {
               key:'details.fax',
               label: 'Fax',
               class:'text-left w-150'
            },
            {
               key:'details.email',
               label: 'Email',
               class:'text-left text-nowrap w-101'
            },
            {
               key:'action',
               label: 'Aksi',
               class:'text-center text-nowrap w-101'
            },
         ],
         pagination:{
            currentPage:1,
            pageSize: 10,
            totalPages: null,
            totalElements:0,
         },
      },
      walidataTable:{
         name:null,
         provinceCode:null,
         cityCode:null,
         isLoading:false,
         items: [],
         fields:[
            {
               key:'no',
               class:'text-center w-51'
            },
            {
               key:'details.province.name',
               label: 'Provinsi',
               class:'text-left w-110'
            },
            {
               key:'details.city.name',
               label: 'Kabupaten/Kota',
               class:'text-left w-110'
            },
            {
               key: 'name',
               label: 'Nama Walidata',
               class:'text-left'
            },
            {
               key:'details.address',
               label: 'Alamat',
               class:'text-left '
            },
            {
               key:'details.phone',
               label: 'No. Telepon',
               thClass:'text-left w-150'
            },
            {
               key:'details.fax',
               label: 'Fax',
               class:'text-left w-150'
            },
            {
               key:'details.email',
               label: 'Email',
               class:'text-left text-nowrap w-101'
            },
            {
               key:'action',
               label: 'Aksi',
               class:'text-center text-nowrap w-101'
            },
         ],
         pagination:{
            currentPage:1,
            pageSize: 10,
            totalPages: null,
            totalElements:0,
         },
      },
      produsenDataTable:{
         name:null,
         province:null,
         city:null,
         isLoading:false,
         items: [],
         fields:[
            {
               key:'no',
               class:'text-center w-51'
            },
            {
               key:'details.province.name',
               label: 'Provinsi',
               class:'text-left w-110'
            },
            {
               key:'details.city.name',
               label: 'Kabupaten/Kota',
               class:'text-left w-110'
            },
            {
               key: 'name',
               label: 'Nama Produsen Data',
               class:'text-left'
            },
            {
               key:'details.address',
               label: 'Alamat',
               class:'text-left '
            },
            {
               key:'details.phone',
               label: 'No. Telepon',
               thClass:'text-left w-150'
            },
            {
               key:'details.fax',
               label: 'Fax',
               class:'text-left w-150'
            },
            {
               key:'details.email',
               label: 'Email',
               class:'text-left text-nowrap w-101'
            },
            {
               key:'action',
               label: 'Aksi',
               class:'text-center text-nowrap w-101'
            },
         ],
         pagination:{
            currentPage:1,
            pageSize: 10,
            totalPages: null,
            totalElements:0,
         },
      },
      modal:{
        error:{
          title:null,
          description:null,
        },
      },
      isSaving:false,
      isDuplicateError:false,
      options:{
         walidata_pusat:[],
         submissionPeriod:[],
         submissionType:[
            {value:'NEW', text:'Baru'},
            {value:'UPDATE', text:'Pemutakhiran'},
         ],
         sdsType:[
            {value:'CONCEPT', text:'Konsep'},
            {value:'VARIABLE', text:'Variabel'},
            {value:'INDICATOR', text:'Indikator'},
         ],
         sdiRole:[
            {id:'PEMBINA_DATA',label:'Pembina Data'},
            {id:'WALIDATA',label:'Walidata'},
            {id:'PRODUSEN_DATA',label:'Produsen Data'},
         ],
         statusTree:[
            {id: 'KabupatenKota', label:'Kabupaten/Kota',children:[
               {id:'DRAFT_KABKOTA', label:'Draft Produsen Data'},
               {id:'SUBMITTED_KABKOTA', label:'Submit Produsen Data'},
               {id:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
               {id:'CORRECTION_KABKOTA', label:'Perbaikan Produsen Data'},
               {id:'PENDING_KABKOTA', label:'Ditunda Walidata'},
               {id:'REJECTED_KABKOTA', label:'Ditolak Walidata'},
               {id:'APPROVED_KABKOTA', label:'Diterima Walidata'},
            ]},
            {id: 'Provinsi', label:'Provinsi',children:[
               {id:'DRAFT_PROVINSI', label:'Draft Produsen Data'},
               {id:'SUBMITTED_PROVINSI', label:'Submit Produsen'},
               {id:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
               {id:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata'},
               {id:'REJECTED_PROVINSI', label:'Ditolak Walidata'},
               {id:'APPROVED_PROVINSI', label:'Diterima Walidata'},
               {id:'PENDING_PROVINSI', label:'Ditunda Walidata'},
            ]},
            {id: 'Pusat', label:'Pusat',children:[
               {id:'DRAFT_PUSAT', label:'Draft Produsen Data'},
               {id:'SUBMITTED_PUSAT', label:'Submit Produsen Data'},
               {id:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
               {id:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata'},
               {id:'REJECTED_PUSAT', label:'Ditolak Walidata'},
               {id:'APPROVED_PUSAT', label:'Diterima Walidata'},
               {id:'PENDING_PUSAT', label:'Ditunda Walidata'},
               {id:'PUBLISHED_PUSAT', label:'Publish'},
            ]},
         ],
         status:[
            {value:'DRAFT_KABKOTA', label:'Draft Produsen Data Kabupaten/Kota'},
            {value:'SUBMITTED_KABKOTA', label:'Submit Produsen Data Kabupaten/Kota'},
            {value:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
            {value:'CORRECTION_KABKOTA', label:'Perbaikan Produsen Data & Walidata Kabupaten/Kota'},
            {value:'PENDING_KABKOTA', label:'Ditunda Walidata Kabupaten/Kota'},
            {value:'REJECTED_KABKOTA', label:'Ditolak Walidata Kabupaten/Kota'},
            {value:'APPROVED_KABKOTA', label:'Diterima Walidata Kabupaten/Kota'},

            {value:'DRAFT_PROVINSI', label:'Draft Produsen Data Provinsi'},
            {value:'SUBMITTED_PROVINSI', label:'Submit Produsen Data Provinsi'},
            {value:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
            {value:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata Provinsi'},
            {value:'REJECTED_PROVINSI', label:'Ditolak Walidata Provinsi'},
            {value:'APPROVED_PROVINSI', label:'Diterima Walidata Provinsi'},
            {value:'PENDING_PROVINSI', label:'Ditunda Walidata Provinsi'},

            {value:'DRAFT_PUSAT', label:'Draft Produsen Data Pusat'},
            {value:'SUBMITTED_PUSAT', label:'Submit Produsen Data Pusat'},
            {value:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
            {value:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata Pusat'},
            {value:'REJECTED_PUSAT', label:'Ditolak Walidata Pusat'},
            {value:'APPROVED_PUSAT', label:'Diterima Walidata Pusat'},
            {value:'PENDING_PUSAT', label:'Ditunda Walidata Pusat'},
            {value:'PUBLISHED_PUSAT', label:'Publish'},
         ],
         subjectField : [],
         requester:[],
         organization:[],
         province:[
          {
            id: 0,
            code: '00',
            name: "PUSAT",
          },
          {
            id: 1,
            code: '11',
            name: "ACEH"
          },
          {
            id: 2,
            code: '12',
            name: "SUMATERA UTARA"
          },
          {
            id: 3,
            code: '13',
            name: "SUMATERA BARAT"
          },
          {
            id: 4,
            code: '14',
            name: "RIAU"
          },
          {
            id: 5,
            code: '15',
            name: "JAMBI"
          },
          {
            id: 6,
            code: '16',
            name: "SUMATERA SELATAN"
          },
          {
            id: 7,
            code: '17',
            name: "BENGKULU"
          },
          {
            id: 8,
            code: '18',
            name: "LAMPUNG"
          },
          {
            id: 9,
            code: '19',
            name: "KEPULAUAN BANGKA BELITUNG"
          },
          {
            id: 10,
            code: '21',
            name: "KEPULAUAN RIAU"
          },
          {
            id: 11,
            code: '31',
            name: "DKI JAKARTA"
          },
          {
            id: 12,
            code: '32',
            name: "JAWA BARAT"
          },
          {
            id: 13,
            code: '33',
            name: "JAWA TENGAH"
          },
          {
            id: 14,
            code: '34',
            name: "DI YOGYAKARTA"
          },
          {
            id: 15,
            code: '35',
            name: "JAWA TIMUR"
          },
          {
            id: 16,
            code: '36',
            name: "BANTEN"
          },
          {
            id: 17,
            code: '51',
            name: "BALI"
          },
          {
            id: 18,
            code: '52',
            name: "NUSA TENGGARA BARAT"
          },
          {
            id: 19,
            code: '53',
            name: "NUSA TENGGARA TIMUR"
          },
          {
            id: 20,
            code: '61',
            name: "KALIMANTAN BARAT"
          },
          {
            id: 21,
            code: '62',
            name: "KALIMANTAN TENGAH"
          },
          {
            id: 22,
            code: '63',
            name: "KALIMANTAN SELATAN"
          },
          {
            id: 23,
            code: '64',
            name: "KALIMANTAN TIMUR"
          },
          {
            id: 24,
            code: '65',
            name: "KALIMANTAN UTARA"
          },
          {
            id: 25,
            code: '71',
            name: "SULAWESI UTARA"
          },
          {
            id: 26,
            code: '72',
            name: "SULAWESI TENGAH"
          },
          {
            id: 27,
            code: '73',
            name: "SULAWESI SELATAN"
          },
          {
            id: 28,
            code: '74',
            name: "SULAWESI TENGGARA"
          },
          {
            id: 29,
            code: '75',
            name: "GORONTALO"
          },
          {
            id: 30,
            code: '76',
            name: "SULAWESI BARAT"
          },
          {
            id: 31,
            code: '81',
            name: "MALUKU"
          },
          {
            id: 32,
            code: '82',
            name: "MALUKU UTARA"
          },
          {
            id: 33,
            code: '91',
            name: "PAPUA BARAT"
          },
          {
            id: 34,
            code: '94',
            name: "PAPUA"
          }
         ],
         city:[
         {
            id: 0,
            code: '0000',
            name: "PUSAT",
            provinsiId:null
         }
        ]
      },
    }
  },
  watch:{
   // 'organization.province.code'(){
   //    this.formProvinceChanged()
   // },
   
   'filter.name'(){
      this.sdiOrganizationTable.pagination.currentPage=1;
      this.getOrganizationSdiList()
   },
   // 'filter.provinceCode'(){
   //    this.provinceChanged(this.filter.provinceCode); 
   //    this.sdiOrganizationTable.pagination.currentPage=1;
   //    this.getOrganizationSdiList() 
   // },
   'appData.current_role'(val, oldVal){
      if(val != oldVal){
         this.initialLoad();
      }
    },
   
  },
  computed:{
   settingTitle(){
      let title = null
      if(this.tab.index == 0){
         title = 'Daftar Pembina Data ' 
      }
      else if(this.tab.index == 1){
         title = 'Daftar Walidata ' 
      }else{
         title = 'Daftar Produsen Data '
      }
      return title;
   },
   settingDescription(){
      let description = null;
      if(this.tab.index == 0){
         description = 'Daftar Pembina Data yang sudah diinputkan';
      }else if(this.tab.index == 1){
         description = 'Daftar Walidata yang sudah diinputkan' 
      }else{
         description = 'Daftar Produsen Data yang sudah diinputkan'
      }
      return description;
   },
   isSuperAdmin(){
      return this.appData.current_role == "ROLE_SUPERADMIN"
   },
   isPembinaData(){
      return this.appData.current_role == "ROLE_PEMBINA_DATA_PUSAT" || this.appData.current_role == "ROLE_PEMBINA_DATA_PROVINSI" || this.appData.current_role == "ROLE_PEMBINA_DATA_KABKOTA";
   },
   isPembinaDataPusat(){
      return this.userRoles.includes("ROLE_PEMBINA_DATA_PUSAT")
   },
   isPembinaDataProvinsi(){
      return this.userRoles.includes("ROLE_PEMBINA_DATA_PROVINSI")
   },
   isPembinaDataKabupatenKota(){
      return this.userRoles.includes("ROLE_PEMBINA_DATA_KABKOTA")
   },
   isWalidata(){
      return this.appData.current_role == "ROLE_WALIDATA_PUSAT" || this.appData.current_role == "ROLE_WALIDATA_PROVINSI" || this.appData.current_role == "ROLE_WALIDATA_KABKOTA";
   
   },
   isWalidataPusat(){
      return this.userRoles.includes("ROLE_WALIDATA_PUSAT");
   },
   isWalidataProvinsi(){
      return this.userRoles.includes("ROLE_WALIDATA_PROVINSI")
   },
   isWalidataKabupatenKota(){
      return this.userRoles.includes("ROLE_WALIDATA_KABKOTA")
   },
   isProdusenData(){
      return this.appData.current_role == "ROLE_PRODUSEN_DATA_PUSAT" || this.appData.current_role == "ROLE_PRODUSEN_DATA_PROVINSI" || this.appData.current_role == "ROLE_PRODUSEN_DATA_KABKOTA";
   },
   isProdusenDataKabupatenKota(){
      return this.userRoles.includes("ROLE_PRODUSEN_DATA_KABKOTA");
   },
   level(){
      return (this.isSuperAdmin || this.isPembinaDataPusat || this.isWalidataPusat) ? 'PUSAT' : ((this.isPembinaDataProvinsi || this.isWalidataProvinsi)? 'PROVINSI' : 'KABUPATEN_KOTA');
   },
    
  },
   inject: ['appData'],
   mounted(){
      this.getUserInfo(store.getters["auth/user"]);
      this.initialLoad();
      this.$nextTick(function () {
         this.initiated = true;
      })
   },
   methods:{
      filterRoleChanged(){
         if(this.initiated){
            this.sdiOrganizationTable.pagination.currentPage=1;
            this.getOrganizationSdiList();
         }
      },
      filterProvinceCodeChanged(){
         if(this.initiated){
            this.updateFilterCityOptions();
            this.sdiOrganizationTable.pagination.currentPage=1;
            this.getOrganizationSdiList();
         }
      },
      filterCityCodeChanged(){
         if(this.initiated){
            this.sdiOrganizationTable.pagination.currentPage=1;
            this.getOrganizationSdiList();
         }
      },
      initialLoad(){
         if(this.appData.current_role){
            this.filter.sdiRole = role.isPembinaData([this.appData.current_role]) ? 'PEMBINA_DATA' : role.isWalidata([this.appData.current_role]) ?  'WALIDATA' : 'PRODUSEN_DATA';
            if(role.isSuperAdmin([this.appData.current_role]) || role.isPembinaDataPusat([this.appData.current_role])){
               // this.filter.provinceCode = this.user.organization.province.code;
               // this.filter.cityCode = null;
               this.provinceFilterDisabled = false;
               this.cityFilterDisabled = false;

               // this.organization.province.code = this.user.organization.province.code;
            }
            else if(role.isPembinaDataProvinsi([this.appData.current_role])){
               // this.filter.provinceCode = this.user.organization.province.code;
               // this.filter.cityCode = null;
               this.provinceFilterDisabled = true;
               this.cityFilterDisabled = false;
               // this.provinceFormDisabled = true;
               // this.organization.province.code = this.user.organization.province.code;
            }
            else if(role.isPembinaDataKabupatenKota([this.appData.current_role]) || role.isWalidata([this.appData.current_role]) || role.isProdusenData([this.appData.current_role])){
               // this.filter.provinceCode = this.user.organization.province.code;
               // this.filter.cityCode = this.user.organization.city.code;
               this.provinceFilterDisabled = true;
               this.cityFilterDisabled = true;

               // this.organization.province.code = this.user.organization.province.code;
               // this.organization.city.code = this.user.organization.city.code;
               this.provinceFormDisabled = true;
               this.cityFormDisabled = true;
            }
            this.filter.provinceCode = this.user.organization.province.code;
            this.updateFilterCityOptions();
            this.filter.cityCode = this.user.organization.city.code;
            this.getOrganizationSdiList()
         }
         
      },
      async getOrganizationSdiList(){
         this.sdiOrganizationTable.items = [];
         this.sdiOrganizationTable.isLoading = true;
         let name = this.filter.name;
         let page = this.sdiOrganizationTable.pagination.currentPage-1;
         let provinceCode = this.filter.provinceCode;
         let cityCode = this.filter.cityCode;
         let roles = [this.filter.sdiRole];
         await SdiOrganizationService.getAllSdiOrganization(page, name, provinceCode, cityCode, roles).then(
            (result)=>{
               this.sdiOrganizationTable.items = result.data.content;
               this.sdiOrganizationTable.pagination.totalElements = result.data.totalElements;
               // this.initial = true;
            },
            (error)=>{
               console.log(error)
            }
         )
         this.sdiOrganizationTable.isLoading = false;
      },
   addSdiOrganization(organizationRole){
      this.organizationRole = organizationRole;
      this.organization = {
         id:null,
         name:null,
         abbreviation:null,
         address:null,
         phone:null,
         fax:null,
         email:null,
         province:{
            code:null,
            name:null
         },
         city:{
            code:null,
            name:null
         },
         level:this.level,
         walidata : null,
      },
      this.isUpdate = false;
      this.isNew = true;

      if(role.isPembinaDataProvinsi([this.appData.current_role])){
         this.organization.province.code = this.user.organization.province.code;
         this.provinceFormDisabled = true;
         this.cityFormDisabled = false;
      }
      else if(role.isPembinaDataKabupatenKota([this.appData.current_role]) || role.isWalidata([this.appData.current_role]) || role.isProdusenData([this.appData.current_role])){
         this.organization.province.code = this.user.organization.province.code;
         this.organization.city.code = this.user.organization.city.code;
         this.provinceFormDisabled = true;
         this.cityFormDisabled = true;
      }else{
         this.provinceFormDisabled = false;
         this.cityFormDisabled = false;
      }

      if(this.organization.province.code){
         this.updateFormCityOptions();
      }

      this.$bvModal.show('modal-add-organization')
   },
   updateSdiOrganization(item){
      this.organizationRole = item.role;
      this.organization = {
         name: item.details.name,
         abbreviation: item.details.abbreviation,
         address: item.details.address,
         phone: item.details.phone,
         fax: item.details.fax,
         email: item.details.email,
         province: item.details.province,
         city: item.details.city,
         level: item.details.level,
         walidata :  null,
      };
      
      this.provinceCode = item.provinceCode;
      this.cityCode = item.cityCode;

      if(this.organization.province.code){
         this.updateFormCityOptions();
      }

      this.isNew = false;
      this.isUpdate = true;
      this.updatedId = item.id;
      this.$bvModal.show('modal-add-organization')
   },
   async saveOrganization(){
      this.isDuplicateError = false;
      this.$bvModal.hide('modal-add-organization');
      this.$bvModal.show('modal-loading');
      this.organization.province.name = this.options.province.find(x=>x.code == this.organization.province.code).name;
      this.organization.city.name = this.options.city.find(x=>x.code == this.organization.city.code).name;
      if(this.organizationRole=='PEMBINA_DATA'){
         await SdsService.addPembinaData(this.organization).then(
            ()=>{
               this.sdiOrganizationTable.pagination.currentPage=1;
               this.getOrganizationSdiList();
            },
         ).catch(error=>{
            if(error.response.data.status == 409){
               this.isDuplicateError = true;
            }else{
               this.toast.title = 'Gagal menyimpan Pembina Data';
               this.toast.message = error.response.data.message;
               this.toast.time = moment().startOf('second').fromNow(); 
               this.$bvToast.show('toast');
            }
         });
      }else if(this.organizationRole=='WALIDATA'){
         await SdsService.addWalidata(this.organization, this.updatedId).then(
            ()=>{
               this.sdiOrganizationTable.pagination.currentPage=1;
               this.getOrganizationSdiList();
            },
         ).catch(error=>{
            if(error.response.data.status == 409){
               this.isDuplicateError = true;
            }else{
               this.toast.title = 'Gagal menyimpan Walidata';
               this.toast.message = error.response.data.message;
               this.toast.time = moment().startOf('second').fromNow(); 
               this.$bvToast.show('toast');
            }
         });
      }else{
         await SdsService.addProdusenData(this.organization).then(
            ()=>{
               this.sdiOrganizationTable.pagination.currentPage=1;
               this.getOrganizationSdiList();
            },
         )
         .catch(error=>{
            if(error.response.data.status == 409){
               this.isDuplicateError = true;
            }else{
               this.toast.title = 'Gagal menyimpan Produsen Data';
               this.toast.message = error.response.data.message;
               this.toast.time = moment().startOf('second').fromNow(); 
               this.$bvToast.show('toast');
            }
         });
      }
      
      this.$bvModal.hide('modal-loading');
   },
   async updateOrganization(){
      this.$bvModal.hide('modal-add-organization');
      this.$bvModal.show('modal-loading');
      this.organization.province.name = this.options.province.find(x=>x.code == this.organization.province.code).name;
      this.organization.city.name = this.options.city.find(x=>x.code == this.organization.city.code).name;

      if(this.organization.province.code == '00'){
         this.organization.level = 'PUSAT';
      }else if(this.organization.province.code != '00' && this.organization.city.code == this.organization.province.code+'00'){
         this.organization.level = 'PROVINSI'
      }else{
         this.organization.level = 'KABUPATEN_KOTA'
      }

      if(this.organizationRole=='PEMBINA_DATA'){
         await SdsService.updatePembinaData(this.organization, this.updatedId).then(
            ()=>{
               this.sdiOrganizationTable.pagination.currentPage=1;
               this.getOrganizationSdiList();
            },
         ).catch(
            error =>{
               this.toast.title = 'Gagal mengupdate Pembina Data';
               this.toast.message = error.response.data.message;
               this.toast.time = moment().startOf('second').fromNow(); 
               this.$bvToast.show('toast');
            }
         );
      }
      if(this.organizationRole=='WALIDATA'){
         await SdsService.updateWalidata(this.organization, this.updatedId).then(
            ()=>{
               this.sdiOrganizationTable.pagination.currentPage=1;
               this.getOrganizationSdiList();
            },
         ).catch(
            error =>{
               this.toast.title = 'Gagal mengupdate Walidata';
               this.toast.message = error.response.data.message;
               this.toast.time = moment().startOf('second').fromNow(); 
               this.$bvToast.show('toast');
            }
         );
      }else{
         await SdsService.updateProdusenData(this.organization, this.updatedId).then(
            ()=>{
               this.sdiOrganizationTable.pagination.currentPage=1;
               this.getOrganizationSdiList();
            }
         ).catch(
            error =>{
               this.toast.title = 'Gagal mengupdate Produsen Data';
               this.toast.message = error.response.data.message;
               this.toast.time = moment().startOf('second').fromNow(); 
               this.$bvToast.show('toast');
            }
         );
      }
      this.$bvModal.hide('modal-loading');
   },
   
   
   
   tabChange(index){
      this.filter.name= null;
      this.tab.index = index;      
      if(!this.provinceFilterDisabled){
         this.filter.provinceCode = null;
      }
   },
   getUserInfo(user){
      this.user = {
        username: user.username,
        name : user.name,
        email: user.email,
        organization: {
          id: user.sdiOrganization.id,
          name: user.sdiOrganization.name,
          address: user.sdiOrganization.details.address,
          province: user.sdiOrganization.details.province,
          city: user.sdiOrganization.details.city,
        } 
      }
      this.userRoles = user.role.slice(1,-1).split(", ");
   },
    
    //MODAL FUNCTION
    //UTILITIES FUNCTION
   loadOptions({callback}) {
      let result = 'Sedang melakukan load data'
      callback(null, result)
   },
   walidataNormalizer(node) {
      return {
         id: node.id,
         label: node.name,
      }
   },
   async walidataLoadOptions({searchQuery, callback}){
      let name = searchQuery;
      let page = 0;
      let provinceCode = '00'
      let cityCode = '0000';
      await SdsService.getWalidata(page, name, provinceCode, cityCode).then(
         (result)=>{
            let options = result.data.content;
            callback(null, options)
         },
         (error)=>{
            console.log(error)
         }
      )
   },
   walidataChanged(){
      this.organization.walidata = {id:this.walidata.id, name:this.walidata.name};
   },
   normalizer(node) {
      return {
         id: node.value,
         label: node.label,
         children: node.children,
      }
   },
   provinceNormalizer(node){
      return {
         id: node.code,
         label: node.name,
      }
   },
   cityNormalizer(node){
      return {
         id: node.code,
         label: node.name,
      }
   },
   canEditPembinaData(item){
      if(role.isPembinaDataPusat(this.userRoles)){
         return true
      }
      if(role.isPembinaDataProvinsi(this.userRoles)  && item.provinceCode == this.user.organization.province.code){
         return true
      }
      if(role.isPembinaDataKabupatenKota(this.userRoles) && item.provinceCode == this.user.organization.province.code && item.cityCode == this.user.organization.city.code){
         return true
      }
      return false
   },
   canEditWalidata(item){
      if(role.isPembinaData(this.userRoles)){
         if(role.isPembinaDataPusat(this.userRoles)){
            return true
         }
         if(role.isPembinaDataProvinsi(this.userRoles) && item.provinceCode == this.user.organization.province.code){
            return true
         }
         if(role.isPembinaDataKabupatenKota(this.userRoles) && item.provinceCode == this.user.organization.province.code && item.cityCode == this.user.organization.city.code){
            return true
         }
      }else if(role.isWalidata(this.userRoles)){
         if(item.provinceCode == this.user.organization.province.code && item.cityCode == this.user.organization.city.code && item.id == this.user.organization.id){
            return true;
         }
      }
      return false;
   },
   canEditProdusenData(item){
      if((this.isPembinaDataPusat || this.isWalidataPusat) && item.provinceCode == '00' && item.cityCode == '0000' ){
         return true;
      }
      else if((this.isPembinaDataProvinsi || this.isWalidataProvinsi) && item.provinceCode == this.user.organization.province.code){
         return true;
      }
      else if((this.isPembinaDataKabupatenKota || this.isWalidataKabupatenKota ) && item.provinceCode == this.user.organization.province.code && item.cityCode == this.user.organization.city.code  ){
         return true;
      }
      else{
         return false
      }
   },
   sdiOrganizationEditable(item){
      if(item.role == 'PEMBINA_DATA'){
         if(role.isPembinaDataPusat([this.appData.current_role])){
            return true
         }
         else if(role.isPembinaDataProvinsi([this.appData.current_role]) && item.provinceCode == this.user.organization.province.code){
            return true
         }
         else if(role.isPembinaDataKabupatenKota([this.appData.current_role]) && item.provinceCode == this.user.organization.province.code && item.cityCode == this.user.organization.city.code){
            return true
         }else{
            false
         }
      }
      else if(item.role == 'WALIDATA' || item.role == 'PRODUSEN_DATA'){
        if(role.isPembinaDataPusat([this.appData.current_role])){
            return true
         }
         else if(role.isPembinaDataProvinsi([this.appData.current_role]) && item.provinceCode == this.user.organization.province.code){
            return true
         }
         else if(role.isPembinaDataKabupatenKota([this.appData.current_role]) && item.provinceCode == this.user.organization.province.code && item.cityCode == this.user.organization.city.code){
            return true
         }
         else if(role.isWalidata([this.appData.current_role]) && item.provinceCode == this.user.organization.province.code && item.cityCode == this.user.organization.city.code){
            return true
         }
         else{
            false
         }
      }else{
         return false
      }
   },
   viewSdiOrganizationUser(item){
      if(item.role == 'PEMBINA_DATA'){
         if(role.isPembinaDataPusat([this.appData.current_role])){
            return true
         }
         else if(role.isPembinaDataProvinsi([this.appData.current_role]) && item.provinceCode == this.user.organization.province.code){
            return true
         }
         else if(role.isPembinaDataKabupatenKota([this.appData.current_role]) && item.provinceCode == this.user.organization.province.code && item.cityCode == this.user.organization.city.code){
            return true
         }else{
            false
         }
      }
      else if(item.role == 'WALIDATA' || item.role == 'PRODUSEN_DATA'){
        if(role.isPembinaDataPusat([this.appData.current_role])){
            return true
         }
         else if(role.isPembinaDataProvinsi([this.appData.current_role]) && item.provinceCode == this.user.organization.province.code){
            return true
         }
         else if(role.isPembinaDataKabupatenKota([this.appData.current_role]) && item.provinceCode == this.user.organization.province.code && item.cityCode == this.user.organization.city.code){
            return true
         }
         else if(role.isWalidata([this.appData.current_role]) && item.provinceCode == this.user.organization.province.code && item.cityCode == this.user.organization.city.code){
            return true
         }
         else{
            false
         }
      }else{
         return false
      }
   },
   showDetailWalidata(item){
      this.organizationDetails = {
         name: item.details.name,
         abbreviation: item.details.abbreviation,
         address: item.details.address,
         phone: item.details.phone,
         fax: item.details.fax,
         email: item.details.email,
         province: item.details.province,
         city: item.details.city,
         level: item.details.level,
         walidata :  item.details.walidata,
      };
      this.$bvModal.show('modal-detail-organization')
   },
   editWalidata(item){
      this.organization = {
         name: item.details.name,
         abbreviation: item.details.abbreviation,
         address: item.details.address,
         phone: item.details.phone,
         fax: item.details.fax,
         email: item.details.email,
         province: item.details.province,
         city: item.details.city,
         level: item.details.level,
         walidata :  item.details.walidata,
      };
      

      this.provinceCode = item.provinceCode;
      this.cityCode = item.cityCode;

      this.$bvModal.show('modal-add-organization')
      this.isNew = false;
      this.isUpdate = true;
      this.updatedId = item.id;
   },
   editProdusenData(item){
      this.organization = {
         name: item.details.name,
         abbreviation: item.details.abbreviation,
         address: item.details.address,
         phone: item.details.phone,
         fax: item.details.fax,
         email: item.details.email,
         province: item.details.province,
         city: item.details.city,
         level: item.details.level,
         walidata :  item.details.walidata,
      };
      
      this.provinceCode = item.provinceCode;
      this.cityCode = item.cityCode;

      this.$bvModal.show('modal-add-organization')
      this.isNew = false;
      this.isUpdate = true;
      this.updatedId = item.id;

      this.walidata =item.details.walidata;
   },
  
   async getPembinaData(){
      this.pembinaDataTable.items = [];
      this.pembinaDataTable.isLoading = true;
      let name = this.filter.name;
      let page = this.pembinaDataTable.pagination.currentPage-1;
      let provinceCode = this.filter.provinceCode;
      let cityCode = this.filter.cityCode;
      await SdsService.getPembinaData(page, name, provinceCode, cityCode).then(
         (result)=>{
            this.pembinaDataTable.items = result.data.content;
            this.pembinaDataTable.pagination.totalElements = result.data.totalElements;
         },
         (error)=>{
            console.log(error)
         }
      )
      this.pembinaDataTable.isLoading = false;
   },
   async getWalidata(){
      this.walidataTable.items = [];
      this.walidataTable.isLoading = true;
      let name = this.filter.name;
      let page = this.walidataTable.pagination.currentPage-1;
      let provinceCode = this.filter.provinceCode;
      let cityCode = this.filter.cityCode;
      await SdsService.getWalidata(page, name, provinceCode, cityCode).then(
         (result)=>{
            this.walidataTable.items = result.data.content;
            this.walidataTable.pagination.totalElements = result.data.totalElements;

         },
         (error)=>{
            console.log(error)
         }
      )
      this.walidataTable.isLoading = false;
   },
   async getProdusenData(){
      this.produsenDataTable.isLoading = true;
      let name = this.filter.name;
      let page = this.produsenDataTable.pagination.currentPage-1;
      let provinceCode = this.filter.provinceCode;
      let cityCode = this.filter.cityCode;
      await SdsService.getProdusenData(page, name, provinceCode, cityCode).then(
         (result)=>{
            this.produsenDataTable.items = result.data.content;
            this.produsenDataTable.pagination.totalElements = result.data.totalElements;
         },
         (error)=>{
            console.log(error)
         }
      )
      this.produsenDataTable.isLoading = false;
   },
   doFilter(){
      if(this.tab.index==0){
         this.getPembinaData();
      }else if(this.tab.index==1){
         this.getWalidata();
      }else{
         this.getProdusenData();
      }
   },
   provinceChanged(provCode){
      if(!this.cityFilterDisabled){
         this.filter.cityCode=null;
      }
      if(provCode == '00'){
         this.options.city = [{
            id: 0,
            code: '0000',
            name: "PUSAT",
            provinsiId:null
         }];
      }else{
         if(provCode){
            let prov = this.options.province.find(x=>x.code == provCode);
            this.getKabupatenKotaList(prov.id, provCode);
         }
      }
   },
   async getKabupatenKotaList(provinceId, provinceCode){
      wilayahService.getKabupatenKotaByIdProvinsi(provinceId).then(
         (result) => {
               let options = result.data.data;
               this.options.city = options.map(x=>({id:x.id, code:x.kode,name:x.nama}));
               this.options.city = [
                  {
                     id: 9999,
                     code: provinceCode+'00',
                     name: "PROVINSI",
                  }, ...this.options.city]
               // if(this.organization.province.code && this.organization.city.code){
               //    this.organization.city.name = this.options.city.find(x=>x.code == this.organization.city.code).name
               // }
         },
         (error) => {
               this.error=error;
         }
      );
   },
   async updateFilterCityOptions(){
      this.filter.cityCode = null;
      let prov = this.options.province.find(x=>x.code == this.filter.provinceCode);
      wilayahService.getKabupatenKotaByIdProvinsi(prov.id).then(
         (result) => {
               let options = result.data.data;
               this.options.city = options.map(x=>({id:x.id, code:x.kode,name:x.nama}));
               this.options.city = [
                  {
                     id: 9999,
                     code: this.filter.provinceCode+'00',
                     name: this.filter.provinceCode == '00' ?  'PUSAT' : 'PROVINSI',
                  }, ...this.options.city]
         },
         (error) => {
               this.error=error;
         }
      );
   },

   async updateFormCityOptions(){
      if(!this.cityFormDisabled){
         this.organization.city.code = null;
      }
      let prov = this.options.province.find(x=>x.code == this.organization.province.code);
      wilayahService.getKabupatenKotaByIdProvinsi(prov.id).then(
         (result) => {
               let options = result.data.data;
               this.options.city = options.map(x=>({id:x.id, code:x.kode,name:x.nama}));
               this.options.city = [
                  {
                     id: 9999,
                     code: this.organization.province.code+'00',
                     name: this.organization.province.code == '00' ?  'PUSAT' : 'PROVINSI',
                  }, ...this.options.city]
         },
         (error) => {
               this.error=error;
         }
      );
   },

   formProvinceChanged(){
      let provCode = this.organization.province.code;
      if(!this.cityFormDisabled){
         this.organization.city.code = null;
      }
      
      if(provCode){
         if(provCode == '00'){
            this.organization.province.name = 'PUSAT'
            this.options.city = [{
               id: 0,
               code: '0000',
               name: "PUSAT",
               provinsiId:null
            }];
            if(this.organization.city.code){
               this.organization.city.name = this.options.city.find(x=>x.code == this.organization.city.code).name
            }
         }else{
            let prov = this.options.province.find(x=>x.code == provCode);
            this.organization.province.name = prov.name
            this.getKabupatenKotaList(prov.id, provCode);
         }
      }
   },
  },

  
  
  
}
</script>
